import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { ClickoutUrl } from '@/helpers/clickout-helper';
import type { TitleDetail } from '@/interfaces/title-details-graphql';
import { getDisneyPromoText } from '@/helpers/disneyPlusPromo';
import { useLanguageStore } from '@/helpers/composables/useStores';


export default /*#__PURE__*/_defineComponent({
  __name: 'DisneyPlusPromo',
  props: {
    title: null
  },
  setup(__props: any) {

const props = __props as { title: TitleDetail }



const { country } = useLanguageStore();

const imgUrl = computed(() => `${JW_CONFIG.IMAGESCALER_URL}/icon/147638351/s100/disneyplus.webp`);
const offerText = computed(() => getDisneyPromoText(country.value));

const clickOutUrl = computed(() =>
	new ClickoutUrl(props.title.watchNowOffer).set('uct_country', country.value).set('uct_tryout', 1).toString()
);

return { __sfc: true,props, country, imgUrl, offerText, clickOutUrl }
}

})